'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var reactQuery = require('react-query');
var StyledThemeProvider = require('../../providers/StyledThemeProvider.js');
var raw = require('./raw.js');
var useReturns = require('../../hooks/useReturns.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var tokens = require('./tokens.js');
var helpers = require('../Pudo/RootElm/helpers.js');
var pudoMethod = require('../../transformers/pudoMethod.js');
var useLanguage = require('../../hooks/useLanguage.js');
var useCurrencyConfig = require('../../hooks/useCurrencyConfig.js');
var nthHookSettings = require('@narvar/nth-hook-settings');
var generated = require('../../graphql/generated.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReviewSummaryC = _ref => {
  var _returnCart$pudoOptio, _returnCart$pudoOptio2;
  let {
    onSubmit,
    onBack,
    progressiveStep,
    activeStep,
    allowRetry
  } = _ref;
  const [policyChecked, setPolicyChecked] = React.useState(false);
  const [mailTo, setMailTo] = React.useState('');
  const {
    orderData,
    selectedItems,
    selectedPudoOption,
    client,
    setReturnCart,
    returnCart,
    userRole
  } = useReturns["default"]();
  const {
    locale
  } = useCurrencyConfig["default"]();
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();
  const {
    value: policyLabelText
  } = useLanguage["default"]({
    langKey: 'returnsReviewPolicyCheckbox'
  });
  const {
    reviewPolicy
  } = nthHookSettings.useSettings();
  const {
    enableReviewPolicy,
    reviewPolicyText
  } = reviewPolicy || {};
  const policyLabel = reviewPolicyText || policyLabelText || '';
  const {
    mutate: setPudoOptionMutation,
    isLoading: loading,
    error: loadingError
  } = reactQuery.useMutation({
    mutationFn: async () => {
      const data = await helpers.setPudoOption({
        client,
        isHipaaCompliant,
        selectedPudoOption,
        returnCart
      });
      setReturnCart(data.setPudoOption);
    }
  });
  const setPudoOptionMutationRef = React.useRef(setPudoOptionMutation);
  React.useEffect(() => {
    setPudoOptionMutationRef.current();
  }, []);
  const submitReturnCardMutationEffect = isHipaaCompliant ? generated.useHipaaSubmitReturnCartMutation : generated.useSubmitReturnCartMutation;
  const [submitReturnCartMutation, {
    error: submitError,
    loading: submitting
  }] = submitReturnCardMutationEffect({
    client,
    variables: {
      returnCartId: (returnCart === null || returnCart === void 0 ? void 0 : returnCart.id) || '',
      mailTo
    },
    onError: err => {
      // eslint-disable-next-line no-console
      if (err) console.log(err);
    },
    onCompleted: _ref2 => {
      let {
        submitReturnCart: submittedReturn
      } = _ref2;
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        value: {
          submittedReturn
        },
        area: 'returnReview',
        event: 'submit'
      });
    }
  });
  const handleBack = () => {
    onBack === null || onBack === void 0 ? void 0 : onBack({
      value: {},
      area: 'returnReview',
      event: 'back'
    });
  };
  const handleSubmit = () => {
    void submitReturnCartMutation();
  };
  const handleChange = event => {
    if (event.subComponent === 'policyCheckbox') {
      var _event$value;
      setPolicyChecked((event === null || event === void 0 ? void 0 : (_event$value = event.value) === null || _event$value === void 0 ? void 0 : _event$value.policyChecked) || false);
    }
    if (event.subComponent === 'mailToInput') {
      var _event$value2;
      setMailTo((event === null || event === void 0 ? void 0 : (_event$value2 = event.value) === null || _event$value2 === void 0 ? void 0 : _event$value2.mailTo) || '');
    }
  };
  const policy = policyLabel && enableReviewPolicy ? {
    policyLabel,
    policyChecked
  } : null;
  return /*#__PURE__*/React__default["default"].createElement(raw.ReviewSummaryRaw, _extends__default["default"]({
    locale,
    progressiveStep,
    activeStep,
    orderItems: (orderData === null || orderData === void 0 ? void 0 : orderData.items) || [],
    hasAssociatedEmail: (orderData === null || orderData === void 0 ? void 0 : orderData.hasAssociatedEmail) ?? true,
    selectedItems: selectedItems || [],
    fees: (selectedPudoOption === null || selectedPudoOption === void 0 ? void 0 : selectedPudoOption.fees) || [],
    dropOffLocation: returnCart === null || returnCart === void 0 ? void 0 : (_returnCart$pudoOptio = returnCart.pudoOption) === null || _returnCart$pudoOptio === void 0 ? void 0 : (_returnCart$pudoOptio2 = _returnCart$pudoOptio.selectedDropOff) === null || _returnCart$pudoOptio2 === void 0 ? void 0 : _returnCart$pudoOptio2.dropOffLocation,
    error: loadingError || submitError,
    loading,
    allowRetry,
    mailTo,
    type: pudoMethod.getPudoMethodName(selectedPudoOption),
    submitting,
    onBack: handleBack,
    onSubmit: handleSubmit,
    onChange: handleChange,
    returnCart,
    userRole
  }, policy));
};
const ReviewSummary = nthHookSettings.withSettingsProvider(StyledThemeProvider.withStyledThemeProvider(ReviewSummaryC, {
  themeTokens: tokens.themeTokens
}), {
  settingsRequested: `
    reviewPolicy {
      reviewPolicyText
      enableReviewPolicy
    }
  `
});

exports.ReviewSummaryRaw = raw.ReviewSummaryRaw;
exports.ReviewSummary = ReviewSummary;
